import { filterCareRecordsForViewer } from "../../services/timeline/recordVisibility";
import { useEffect, useState } from "react";
import { collection, doc, onSnapshot, query, where } from "firebase/firestore";
import { db } from "../../services/firebase";
import { getCareSourceTimelineEntryIds } from "./careSourceStatusModel";
import { normalizeSourceResultEntries } from "./sourceResultEntries";

export const useSourceResults = (
  sourceId,
  setCurrentChildId,
  getUserRoleForChild,
) => {
  const [state, setState] = useState({
    source: null,
    entries: [],
    loading: Boolean(sourceId),
    error: "",
  });
  useEffect(() => {
    let active = true,
      source = null,
      logs = null,
      childId = null;
    let unsubscribeEntries = () => {};
    const fail = (error) => {
      source = null;
      if (active)
        setState({
          source: null,
          entries: [],
          loading: false,
          error: error.message || "We could not load this capture.",
        });
    };
    const publish = () => {
      if (!active || !source || !logs) return;
      const linkedIds = new Set(getCareSourceTimelineEntryIds(source));
      const entries = filterCareRecordsForViewer(
        normalizeSourceResultEntries(
          logs.filter(
            (entry) =>
              linkedIds.has(entry.id) ||
              (entry.sourceNoteId ||
                entry.source?.sourceNoteId ||
                entry.metadata?.sourceNoteId) === sourceId,
          ),
        ),
        getUserRoleForChild?.(source.childId),
      );
      setState({ source, entries, loading: false, error: "" });
    };
    setState({
      source: null,
      entries: [],
      loading: Boolean(sourceId),
      error: "",
    });
    if (!sourceId) {
      fail(new Error("This source could not be found."));
      return undefined;
    }
    const unsubscribeSource = onSnapshot(
      doc(db, "careSources", sourceId),
      (snapshot) => {
        if (!active) return;
        if (!snapshot.exists()) {
          fail(new Error("This source could not be found."));
          return;
        }
        source = { ...snapshot.data(), id: snapshot.id };
        if (!source.childId) {
          fail(new Error("This capture is missing its profile."));
          return;
        }
        if (childId !== source.childId) {
          unsubscribeEntries();
          logs = null;
          childId = source.childId;
          const subscribedChildId = childId;
          setCurrentChildId?.(childId);
          // Match the Timeline's child-scoped stream: metadata can lag behind a saved row.
          unsubscribeEntries = onSnapshot(
            query(collection(db, "dailyLogs"), where("childId", "==", childId)),
            (snapshot) => {
              if (!active || childId !== subscribedChildId) return;
              logs = snapshot.docs.map((entry) => ({
                ...entry.data(),
                id: entry.id,
                collection: "dailyLogs",
              }));
              publish();
            },
            fail,
          );
        }
        publish();
      },
      fail,
    );
    return () => {
      active = false;
      unsubscribeSource();
      unsubscribeEntries();
    };
  }, [sourceId, setCurrentChildId, getUserRoleForChild]);
  return state;
};
